import { getScreenName } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const fireViewedColorPage = (pageName) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: pageName || getScreenName(),
  });
};

export const fireClickedCard = (cardName, support, pageName) => {
  fireEvent({
    category: 'clicked_card_in_general_screen',
    card_name: cardName,
    screen_name: pageName || getScreenName(),
    support_variable: support || '',
  });
};

export const fireClickedDowload = (pageName) => {
  fireEvent({
    category: 'clicked_cta',
    cta: 'Download',
    screen_name: pageName,
  });
};
